<template>
  <div>

    <!-- Adviseurs omgeving -->
    <div v-if="allClients !== null && allClients.length || role == 1">
      <div id="firstMenubar" class="row menubar">
        <div class="title">{{role == 1 ? 'Mijn klanten' : 'Machtigingen'}}</div>
        <a
          v-if="style=='db'"
          href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-online-machtiging-adviseur.pdf"
          target="_blank"
          class="button"
          style="float:right;"
        >
          <awesomeIcon icon="handshake"/> <span class="mobile-hidden">Lees Voorwaarden</span>
        </a>
        <div
          class="hide-desktop dropdown right"
          style="float:right;width: 211px;"
          v-if="allClients !== null"
        >
          <button class="dropdown-button" @click="dropdownlist = !dropdownlist">
            <awesomeIcon icon="sort" /> {{ find(pages, {value: currentAtpView }).label}}
          </button>
          <div
            class="dropdown-bg"
            v-if="dropdownlist"
            @click="dropdownlist = !dropdownlist"
          ></div>
          <ul class="dropdown-list" v-if="dropdownlist">
            <li
              v-for="(group) in pages"
              :key="group.value"
              @click="
                dropdownlist = !dropdownlist;
                currentAtpView = group.value
              "
            >
              {{ group.label }}
            </li>
            <li class="dropdown-cancel" @click="dropdownlist = !dropdownlist">Annuleren</li>
          </ul>
        </div>
      </div>
      <div class="card inset-small marginbottom" v-if="role == 1">
        <h3>Welkom!</h3>
        <p>
          U bent in uw adviseurs omgeving waar u inzage in uw klantendossiers heeft. Om inzage
          in het dossier van uw klant te krijgen vraagt u om een machtiging. Daarvoor klikt u op
          ‘Nieuwe klant’ hier rechtsboven, lees ook de bijbehorende voorwaarden. Tevens kunt u dan
          een rekeningaanvraag starten en bestaande klanten aan uw omgeving toevoegen.
        </p>
        <p>
          Hieronder vindt u een link naar handige documenten en formulieren. En u kunt direct een
          offerte aanvragen voor een van onze bancaire lijfrente oplossingen zoals Leefrente.
        </p>
        <a
          @click="viewPage('DocCenter')"
          class="button horizontal"
        >
          Documenten bekijken
        </a>
        <a
          href="https://www.doelbeleggen.nl/atp/offerte-aanvraag/"
          target="_blank"
          class="button horizontal"
        >
          Offerte aanvragen
        </a>
        <p>Met vriendelijk groet,</p>
        <p>Tjade Groot<br>Team Doelbeleggen</p>
      </div>

      <!-- Onboarding overview -->
      <div id="atpWindow" key="clients" class="card" v-if="allClients !== null">
        <div class="hide-mobile row menubar">
          <button
            v-for="(group) in pages"
            :key="group.value"
            @click="currentAtpView = group.value"
            :class="{
              'fontBold' : currentAtpView == group.value
            }"
          >
            {{ group.label }}
          </button>
        </div>
        <component :is="currentAtpView" />
      </div>
    </div>
    <div key="loader" class="loader" v-else-if="allClients === null" />
    <div class="card" v-if="filter(advised, (o) => o.accepted).length > 0">
      <div class="menubar roundedtop">
        <div class="title">
         Mijn adviseur(s)
        </div>
        <a
          v-if="style=='db'"
          href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-online-machtiging-adviseur.pdf"
          target="_blank"
          class="button"
          style="float:right;"
        >
          <awesomeIcon icon="handshake"/>
          <span class="mobile-hidden">Voorwaarden machtiging adviseur</span>
        </a>
      </div>
      <div
        class="content card inset"
        v-for="(adviser, index) in advised"
        :key="index"
      >
        <div>
          <h2 class="title">
            <awesomeIcon icon="user-tie" />
              {{ adviser.atpData.advisor_name }}
              {{ adviser.atpData.advisor_infix }}
              {{ adviser.atpData.advisor_surname }}
          </h2>
          <button
            @click="removeMandateModal = true"
            class="secondary"
            style="float:right"
          >
            <awesomeIcon icon="times"/> Machtiging intrekken
          </button>
        </div>
        <br /><br />
        <div class="flex-container">
        <div
          v-if="adviser.atpData.name"
          class="flex-33 card fakeOption"
        >
          <awesomeIcon class="iconGreen" icon="map-marker-alt"/>
          <h2>{{ adviser.atpData.name || '?'}}</h2> <br />
          <h4>
            {{ adviser.atpData.street }}
            {{ adviser.atpData.housenr }}
            {{ adviser.atpData.housenr_addition }} <br />
            {{ adviser.atpData.postal }}, {{ adviser.atpData.city }}<br />
          </h4>
        </div>

        <div
          v-if="adviser.atpData.phone"
          class="flex-33 card fakeOption"
        >
          <awesomeIcon class="iconGreen" icon="phone-alt"/>
          <h2 class="concat">
            <a :href="atpPhone(adviser.atpData.phone)">{{ adviser.atpData.phone }}</a>
          </h2>
          <button
            v-if="!copyPhone"
            class="secondary"
            @click="copyURL(adviser.atpData.phone, 'phone')"
          >
            <awesomeIcon icon="copy" size="xs"/>
            Telefoonnummer kopiëren
          </button>
          <span v-else>
            <awesomeIcon icon="check" size="xs"/>
            Telefoonnummer gekopieerd!
          </span>
          <br /><br />
          Klik op het telefoonnummer om contact op te nemen met uw adviseur.
        </div>

        <div
          class="flex-33 card fakeOption"
        >
          <awesomeIcon class="iconGreen" icon="envelope"/>
          <h2 class="concat">
            <a :href="atpMail(adviser.atpData.email)">
              {{ adviser.atpData.email }}
            </a>
          </h2>
          <button
            v-if="!copyEmail"
            class="secondary"
            @click="copyURL(adviser.atpData.email,'email')"
          >
            <awesomeIcon icon="copy" size="xs"/>
            E-mailadres kopiëren
          </button>
          <span v-else>
            <awesomeIcon icon="check" size="xs"/>
            E-mailadres gekopieerd!
          </span>
          <br /><br />
          Klik op het e-mailadres om een e-mail te versturen naar uw adviseur.
        </div>

        <div
          v-if="adviser.atpData.website"
          class="flex-33 card fakeOption"
        >
          <awesomeIcon class="iconGreen" icon="globe"/>
          <h2>
            <a :href="adviser.atpData.website" target="_blank">
              {{ readableWebsite(adviser.atpData.website) }}
            </a>
          </h2> <br /><br />
          Klik op de website om naar de website van uw adviseur te gaan.
        </div>

        <div
          class="flex-33 card fakeOption"
        >
          <awesomeIcon class="iconGreen" icon="marker"/>
          <h2>
            {{
              new Date(adviser.accepted).toLocaleString(
                'nl-NL',
                { year: 'numeric', month: 'long', day: 'numeric' }
              )
            }}
          </h2> <br /><br />
          U heeft op deze datum de machtiging van uw adviseur geaccepteerd.
        </div>

      </div>
      </div>
    </div>
    <div v-else-if="advised.length === 0">
      <p class="msg">U heeft geen machtigingen.</p>
    </div>
    <modalWindow v-if="removeMandateModal" @close="removeMandateModal = false" width="300">
      <div class="titlebar">
        Waarschuwing
      </div>
      <div class="card inset">
        Als u de machtiging voor uw adviseur wil intrekken heeft dit gevolgen voor uw
        samenwerking. <br><br> Dit houdt in dat uw adviseur niet meer met u mee kan kijken en ook
        niet meer kan adviseren over uw situatie. <br><br>
        Wij verzoeken u om eerst contact met uw adviseur op te nemen om deze veranderingen te
        bespreken. <br><br>
        Voor andere vragen kunt u ook direct contact met ons opnemen.
        <button @click="removeMandateModal = false">
          Terug
        </button>
        <div
          v-if="Number(role) > 9 || Number(sdk.isBecome) === 2"
          class="form-error-red"
          style="margin-top: 10px"
          @click="removeMandate()"
        >
          Toch intrekken (ADMIN)
        </div>
      </div>
    </modalWindow>
  </div>
</template>

<script>
import { find, filter } from 'lodash-es';
import onboardingAccepted from './atp/onboardingAccepted';
import onboardingAll from './atp/onboardingAll';
import onboardingAuthorized from './atp/onboardingAuthorized';
import onboardingHanded from './atp/onboardingHanded';
import onboardingIntake from './atp/onboardingIntake';
import onboardingPending from './atp/onboardingPending';
import onboardingSigned from './atp/onboardingSigned';

export default {
  name: 'UserMandates',
  components: {
    onboardingAccepted,
    onboardingAll,
    onboardingAuthorized,
    onboardingHanded,
    onboardingIntake,
    onboardingPending,
    onboardingSigned,
  },
  data() {
    return {
      copyEmail: false,
      copyPhone: false,
      advised: [],
      selectedTab: 'alles',
      resultsPerPage: 20,
      style: process.env.VUE_APP_STYLE,
      clientsPending: null,
      clientsAccepted: null,
      intakes: null,
      intakesHanded: null,
      intakesAccepted: null,
      intakesSigned: null,
      allClients: null,
      currentAtpView: 'onboardingPending',
      dropdownlist: false,
      removeMandateModal: false,
    };
  },
  created() {
    this.getMandates();
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    pages() {
      return [
        {
          label: `Verzoek in afwachting (${this.clientsPending.length})`,
          value: 'onboardingPending',
        }, {
          label: `Nieuwe toegang (${this.clientsAccepted.length})`,
          value: 'onboardingAuthorized',
        }, {
          label: `Bezig met vragenlijst (${this.intakes.length})`,
          value: 'onboardingIntake',
        }, {
          label: `Vragenlijst ingediend (${this.intakesHanded.length})`,
          value: 'onboardingHanded',
        }, {
          label: `Wacht op akkoord (${this.intakesAccepted.length})`,
          value: 'onboardingAccepted',
        }, {
          label: `Rekening akkoord (${this.intakesSigned.length})`,
          value: 'onboardingSigned',
        }, {
          label: `Alle klanten (${this.allClients.length})`,
          value: 'onboardingAll',
        },
      ];
    },
  },
  methods: {
    find,
    filter,
    removeMandate() {
      this.$store.state.confirm.toggle({
        text: `Let op: bij het intrekken van het mandaat worden ook de vragenlijsten
        verwijderd.<br><br> Weet u zeker dat u dit mandaat wilt intrekken?`,
        confirmText: 'Intrekken',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.removeMandate(Number(filter(
              this.advised,
              (o) => o.accepted,
            )[0].atpData.client), (response) => {
              if (response.status === 200) {
                window.location.reload();
              }
            });
          }
        },
      });
    },
    copyURL(mytext, type) {
      navigator.clipboard.writeText(mytext);
      if (type === 'email') {
        this.copyEmail = true;
        setTimeout(() => {
          this.copyEmail = false;
        }, 2000);
      } else {
        this.copyPhone = true;
        setTimeout(() => {
          this.copyPhone = false;
        }, 2000);
      }
    },
    readableWebsite(url) {
      let newUrl = '';
      if (url) {
        if (url.startsWith('https://')) {
          newUrl = url.slice(8);
        }
        if (url.startsWith('http://')) {
          newUrl = url.slice(7);
        }
      }
      return newUrl;
    },
    atpPhone(nr) {
      let tel = 'tel: ?';
      if (nr) {
        const convertedNumber = nr
          .replace(/[^\d+]/g, '')
          .replace(/^\+/g, '00')
          .replace(/[^\d]/g, '')
          .replace(/^00/g, '+')
          .replace(/^0/g, '+31');
        tel = `tel:${convertedNumber}`;
      }
      return tel;
    },
    atpMail(mail) {
      return `mailto:${mail}`;
    },
    viewPage(page) {
      this.$store.state.currentView = page;
    },
    acceptMandate(user) {
      this.$store.state.confirm.toggle({
        text: 'Lees voor het accepteren de bijbehorende voorwaarden goed door.',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.acceptMandate(user, (response) => {
              if (response.status === 200) {
                this.getMandates();
              }
            });
          }
        },
      });
    },
    becomeUser(user, intake = null) {
      this.sdk.become(user, (response) => {
        if (response.status === 200) {
          if (intake) {
            window.location.href = `?intake=${intake}`;
          } else {
            window.location.reload();
          }
        }
      });
    },
    clearMessage() {
      this.msg = { msg: null, type: 'notice' };
    },
    getMandates() {
      this.sdk.getMandates((response) => {
        if (response.status === 200) {
          const tempClientsPending = [];
          const tempClientsAccepted = [];
          const tempIntakes = [];
          const tempIntakesHanded = [];
          const tempIntakesAccepted = [];
          const tempIntakesSigned = [];
          for (let i = 0; i < response.data.advisorFor.length; i += 1) {
            if (!response.data.advisorFor[i].intakes) {
              response.data.advisorFor[i].intakes = [];
            }
            if (!response.data.advisorFor[i].ports) {
              response.data.advisorFor[i].ports = [];
            }
            response.data.advisorFor[i].aantal = Math.max(
              response.data.advisorFor[i].intakes.length
              + response.data.advisorFor[i].ports.length,
              1,
            );
            for (let j = 0; j < response.data.advisorFor[i].intakes.length; j += 1) {
              const parsedObject = JSON.parse(
                response.data.advisorFor[i].intakes[j].intake || '{}',
              );
              parsedObject.progress = (Number(parsedObject.wrongFields)
                / Math.max(Number(parsedObject.totalFields), 21)) * 100;
              if (Number.isNaN(parsedObject.progress)) {
                parsedObject.progress = 0;
              }
              response.data.advisorFor[i].intakes[j].intakeData = parsedObject;
            }
            if (response.data.advisorFor[i].accepted == null) {
              tempClientsPending.push(response.data.advisorFor[i]);
            } else if (
              !response.data.advisorFor[i].intakes.length
              && !response.data.advisorFor[i].ports.length
            ) {
              tempClientsAccepted.push(response.data.advisorFor[i]);
            }
            if (filter(
              response.data.advisorFor[i].intakes,
              (o) => o.status === 'Bezig' && !o.redo,
            ).length) {
              tempIntakes.push(response.data.advisorFor[i]);
            }
            if (filter(
              response.data.advisorFor[i].intakes,
              (o) => o.status === 'Ingeleverd' && !o.redo,
            ).length) {
              tempIntakesHanded.push(response.data.advisorFor[i]);
            }
            if (filter(
              response.data.advisorFor[i].intakes,
              (o) => o.status === 'Geaccepteerd' && !o.redo,
            ).length) {
              tempIntakesAccepted.push(response.data.advisorFor[i]);
            }
            if (filter(
              response.data.advisorFor[i].intakes,
              (o) => o.status === 'Ondertekend' && !o.redo,
            ).length) {
              tempIntakesSigned.push(response.data.advisorFor[i]);
            }
            response.data.advisorFor[i].status = response.data.advisorFor[i].accepted == null
              ? 'Nog niet geaccepteerd'
              : 'Geaccepteerd';
            response.data.advisorFor[i].hasPorts = response.data.advisorFor[i].ports
              ? response.data.advisorFor[i].ports.length
              : 0;
          }
          this.clientsPending = tempClientsPending;
          this.clientsAccepted = tempClientsAccepted;
          this.intakes = tempIntakes;
          this.intakesHanded = tempIntakesHanded;
          this.intakesAccepted = tempIntakesAccepted;
          this.intakesSigned = tempIntakesSigned;
          this.allClients = response.data.advisorFor;
          this.$store.state.mandates = response.data.advisedBy || [];
          for (let i = 0; i < response.data.advisedBy.length; i += 1) {
            if (response.data.advisedBy[i].accepted) {
              this.sdk.getAtpDetailsForUser(
                response.data.advisedBy[i].advisor,
                (atpResponse) => {
                  if (atpResponse.status === 200) {
                    const atp = atpResponse.data[0];
                    this.advised.push(
                      {
                        accepted: response.data.advisedBy[i].accepted,
                        atpData: atp || {
                          advisor_name: response.data.advisedBy[i].email,
                          email: response.data.advisedBy[i].email,
                        },
                      },
                    );
                  }
                },
              );
            } else {
              this.advised = response.data.advisedBy || [];
            }
          }
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media #{$mobile} {
  #atpWindow {
    padding-top: 36px;
  }
  #firstMenubar {
    top: 91px !important;
  }
}
.fontBold {
  font-weight: 600;
}
.button.horizontal {
  margin: 10px;
  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
}
.flex-container {
  column-gap: 20px;
  row-gap: 20px;
  @media #{$mobile} {
    row-gap: 10px;
    padding: 43px 10px 10px;
  }
}
.iconGreen {
  font-size: 40px;
  color: $color-highlight;
  margin-bottom: 10px;
}
.fakeOption {
  text-align: left;
  overflow: hidden;
  background: #eff1f6;
  border-radius: $br;
  padding: 20px;
  color: $color-background;
  height: 200px;
  text-align: center;
}
</style>
